"use client";

import { i18nStore } from "./i18n";
import { useUpdateEffect } from "ahooks";
import { useHydrateAtoms } from "jotai/utils";
import { useLocale, useMessages } from "next-intl";

export function InitI18n() {
  const messages = useMessages();
  const locale = useLocale();

  useHydrateAtoms([
    [i18nStore.locale, locale],
    [i18nStore.messages, messages],
  ]);

  useUpdateEffect(() => {
    i18nStore.setContext(locale, messages);
  }, [locale, messages]);

  return null;
}
